import type { StoryTemplateWithUrls } from 'schemas';
import { StoryTemplatesResponseSchema } from 'schemas';
import { apiRequest } from '@/api/helpers/apiRequest';
import { handleApiError } from '@/api/helpers/handleApiError';

export const fetchStoryTemplates = async (): Promise<
  StoryTemplateWithUrls[]
> => {
  try {
    return await apiRequest(
      'GET',
      '/api/story-templates',
      undefined,
      StoryTemplatesResponseSchema
    );
  } catch (error) {
    handleApiError(error);
  }
};
